import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../../services/auth.service';
import { storeToken } from '../../utils/tokenManager';

/**
 * Protected Route component that checks for valid authentication
 * Redirects to login if no valid token is found
 * 
 * TEMPORARY: Authentication disabled for local testing
 */
function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true = authenticated, false = not authenticated
  const [isLoading, setIsLoading] = useState(true);

  // TEMPORARY: Check if running on localhost
  const isLocalDevelopment = false
  // const isLocalDevelopment = window.location.hostname === 'localhost' || 
  //                           window.location.hostname === '127.0.0.1';

  useEffect(() => {
    // Skip authentication check for local development
    if (isLocalDevelopment) {
      // Set dummy user data for local testing
      const dummyToken = 'dummy-local-token-' + Date.now();
      const dummyDecodedData = {
        Email: 'testuser@localhost.com',
        Name: 'Test User',
        Roles: [
          {
            RoleName: 'Developer',
            Components: [
              {
                ComponentId: 'YDqe',
                ComponentName: 'Report Generator'
              }
            ]
          }
        ],
        // Add expiry info for token manager (24 hours for local dev)
        exp: Math.floor(Date.now() / 1000) + (24 * 60 * 60) // 24 hours from now in Unix timestamp
      };
      
      // Store token with expiry using tokenManager
      storeToken(dummyToken, dummyDecodedData);
      
      // Also store decoded data and email for compatibility
      localStorage.setItem('decodedTokenData', JSON.stringify(dummyDecodedData));
      localStorage.setItem('userEmail', 'testuser@localhost.com');
      
      setIsAuthenticated(true);
      setIsLoading(false);
      return;
    }

    const checkAuthentication = async () => {
      try {
        setIsLoading(true);
        const tokenIsValid = await isTokenValid();
        setIsAuthenticated(tokenIsValid);
      } catch (error) {
        console.error('Authentication check failed:', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, [isLocalDevelopment]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render children if authenticated
  return children;
}

export default ProtectedRoute;